import { G } from '@mobily/ts-belt';
import { useRecordContext } from 'react-admin';

import { B2bContract } from '@Common/types/bo/b2b/contracts';

import { ShowFields, ShowSection } from '@sh4res/bo-common/components';
import { CurrencyField } from '@sh4res/bo-common/fields';

export const CeilingSection = () => {
  const record = useRecordContext<B2bContract>();

  if (G.isNullable(record) || record.total_contribution_ceiling === null) {
    return null;
  }

  return (
    <ShowSection
      label="resources.bo_common.b2b.contracts.fields.total_contribution_ceiling"
      record={record}>
      <ShowFields<B2bContract>
        resource="bo_common.b2b.contracts"
        fields={{
          total_contribution_ceiling: (
            <CurrencyField
              currency="EUR"
              testId="BoExternalB2BPlansTotalContributionCeilingSection_CurrencyField"
            />
          ),
        }}
      />
    </ShowSection>
  );
};
